<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
          <v-img alt="suche-regional.at" class="shrink mr-2" contain src="@/assets/logo.svg" transition="scale-transition" width="40"/>
          <h1>suche-regional.at</h1>
      </div>
      <v-spacer></v-spacer>
      <div id="nav">
        <router-link to="/">Home</router-link> | <router-link to="/about">Über uns</router-link>
      </div>
    </v-app-bar>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'App',
    methods: {
      ...mapActions(['getCategories', 'getFilterOptions']),
    },
    async created() {
      // load on init
      await this.getCategories();
      await this.getFilterOptions();
    }
  }
</script>

<style lang='scss'>
  @import "./styles/base.scss";
</style>